// Load Razorpay Checkout script once and open the modal.
import { api } from '@/lib/api';

const SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';
let scriptPromise = null;

const loadScript = () => {
  if (typeof window === 'undefined') return Promise.reject(new Error('no window'));
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { scriptPromise = null; reject(new Error('Failed to load Razorpay')); };
    document.body.appendChild(s);
  });
  return scriptPromise;
};

/**
 * Open Razorpay Checkout.
 * @param {object} opts
 *   amount: rupees (int),
 *   purpose: 'consultation' | 'order',
 *   reference_id?: string,
 *   name?, email?, contact?: prefill,
 *   description?: string,
 *   theme_color?: string
 * @returns Promise<{ payment_id: string }> resolved after signature-verified on server, rejected on user close / failure.
 */
export const openRazorpay = async (opts) => {
  await loadScript();
  const { data: order } = await api.post('/payments/create-order', {
    amount: opts.amount,
    currency: 'INR',
    purpose: opts.purpose,
    reference_id: opts.reference_id || null,
  });
  if (!order.key_id) throw new Error('Razorpay not configured on server');

  return new Promise((resolve, reject) => {
    const rz = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.payment_id,
      name: 'Saans Ayurved',
      description: opts.description || 'Saans Ayurved',
      image: '/logo192.png',
      theme: { color: opts.theme_color || '#2C302E' },
      prefill: {
        name: opts.name || '',
        email: opts.email || '',
        contact: opts.contact || '',
      },
      modal: {
        ondismiss: () => reject(new Error('Payment cancelled')),
      },
      handler: async (resp) => {
        try {
          await api.post('/payments/verify', {
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          resolve({ payment_id: resp.razorpay_order_id, razorpay_payment_id: resp.razorpay_payment_id });
        } catch (e) {
          reject(e);
        }
      },
    });
    rz.on('payment.failed', (resp) => {
      reject(new Error(resp?.error?.description || 'Payment failed'));
    });
    rz.open();
  });
};
